export { default } from '@/features/map/MapScreen';
